import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
//sets other settings if it is not already saved in the browser
if (!localStorage.otherSettings) {
    localStorage.otherSettings = JSON.stringify({
        showTotalRow: true, 
        hideModalAfterSubmit: true, 
        speedRound: false, 
        saveOnMonthChange: true, 
        hideInactiveProducts: false, 
        specificForecastProducts: true
    })
}
export default new Vuex.Store({
    state: {
        preorder: { switch: false, discount: 0 },
        otherSettings: JSON.parse(localStorage.otherSettings),
        errors:[]
    },
    getters: {
        getOtherSettings(state) {
            return state.otherSettings
        },
        getPreorder(state) {
            return state.preorder
        },
    },
    mutations: {
        CHANGE_OTHER_SETTINGS (state, otherSettings) {
            state.otherSettings = otherSettings
        },
        CHANGE_PREORDER(state, preorder) {
            state.preorder = preorder
        },
        ERROR(state, error) {
            state.errors.push(error)
        },
        CHANGE_PREORDER_DISCOUNT(state, discount) {
            state.preorder.discount = discount
        }
    },
    actions: {
        updateOtherSettings({commit},otherSettings) {
            try {
                commit('CHANGE_OTHER_SETTINGS', otherSettings)
            } catch (error) {
                commit('ERROR',error)
            }
        },
        updatePreorder({commit},preorder) {
            try {
                commit('CHANGE_PREORDER', preorder)
            } catch (error) {
                commit('ERROR',error)
            }
        },
        updatePreorderDiscount({commit},discount) {
            try {
                commit('CHANGE_PREORDER_DISCOUNT',discount)
            } catch (error) {
                commit('ERROR',error)
            }
        }
    }
})